import React, {Component} from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import styles from "./EventItem.scss";
import classNames from "classnames";
import {_deleteEvent, _updateStatusEvent} from "../../../../../services/apis/EventServices";
import {Button} from 'reactstrap'
import ModalUpdateEvent from "./ModalUpdateEvent";


class EventItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalDisplay: false,
        };
        this._handleOpenModal = this._handleOpenModal.bind(this);
        this._handleCloseModal = this._handleCloseModal.bind(this);

    }

    _handleClickRemove = () => {
        const {event} = this.props;

        _deleteEvent(event._id)
            .then(result => {
                const {success} = result;

                if (success) {
                    this.props.onRemove && this.props.onRemove(event._id);
                }
            });
    };

    _handleClickUpdateStatus = (e) => {
        e.preventDefault();
        const {event} = this.props;
        const {status, _id} = event;

        const statusUpdate = status === 'active' ? 'inactive' : 'active';

        _updateStatusEvent(_id, statusUpdate)
            .then(result => {
                const {success, data} = result;

                if (success) {
                    const eventUpdated = {
                        ...event,
                        status: data
                    };

                    this.props.onUpdate && this.props.onUpdate(_id, eventUpdated);
                }
            });
    };

    _handleOpenModal() {
        this.setState({
            isModalDisplay: true,
        });
    }

    _handleCloseModal() {
        this.setState({
            isModalDisplay: false,
        });
    }

    render() {
        const {event, onUpdate} = this.props;

        const {time, type, query, description, area, thumbnail, name, status} = event;
        const timeMoment = Moment(time);

        const {keyword} = query;

        return (
            <div className={classNames(styles.event, styles[status])}>
                <div className="d-flex">
                    <div className={styles.left}>
                        {
                            thumbnail && <div className={styles.thumbnail}><img src={thumbnail} alt={name}/></div>
                        }
                    </div>
                    <div className="right">
                        <div className={styles.name}>{name}</div>
                        <div className={styles.time}>Time: {timeMoment.format('DD/MM/YYYY')}</div>

                        <div className={styles.query}>
                            {
                                keyword && <div className={styles.keyword}>Keyword: <strong>{keyword}</strong></div>
                            }
                        </div>

                        {
                            description && <div className={styles.description}>{description}</div>
                        }

                        {
                            area && <div className={styles.area}>Area: {area}</div>
                        }

                        {
                            type && <div className={styles.type}>Type: {type}</div>
                        }

                        <button
                            onClick={this._handleClickUpdateStatus}
                            className={classNames("btn", status === 'active' ? 'btn-secondary' : 'btn-primary')}>
                            {
                                status === 'active' ? 'Disable' : 'Enable'
                            }
                        </button>
                        <Button color="danger" onClick={this._handleOpenModal}>Edit</Button>


                    </div>
                </div>

                <div onClick={this._handleClickRemove} className={styles.remove}>x</div>


                <ModalUpdateEvent onOpenModal={this._handleOpenModal} onCloseModal={this._handleCloseModal}
                                  isModelDisplay={this.state.isModalDisplay}
                                  onUpdate={onUpdate} event={event}/>


            </div>
        );
    }
}

EventItem.propTypes = {
    event: PropTypes.object,
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
};

export default EventItem;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventItem/EventItem.js